// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Afidium
import { BtnModule } from 'libraries/ui_button/btn.module';
import { TextFieldModule } from 'libraries/module/formbuilder/fields/text-field/text-field.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { SashaBreadcrumbModule } from '../../shared/components/breadcrumb/sasha-breacrumb.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { ProcessingEmailService } from './services/processing-email.service';
import { MailBreadcrumbService } from './services/email-breadcrumb.service';
import { HasEmailDataGuard } from './guards/has-email-data.guard';
import { ProcessingEmailRouting } from './processing-email.routing';
import { EmailFormModule } from './components/email-form/email-form.module';
import { EmailValidationModule } from './components/email-validation/email-validation.module';
import { ListModule } from 'libraries/module/list.module';
import { ProcessingEmailComponent } from './processing-email.component';
import { HasSyscodesGuard } from '../../shared/guards/has-syscodes.guard';
import { TemplateListModule } from '../../shared/components/template-list/template-list.module';
import { ProcessingEmailResourceModule } from 'app_sasha/shared/resources/processing-email-resource/processing-email-resource.module';
import { BreadcrumbModule } from 'libraries/component/breadcrumb/breadcrumb.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ProcessingEmailRouting,
        BtnModule,
        ProcessingEmailResourceModule,
        TextFieldModule,
        NotificationModule,
        LoaderModule,
        SashaBreadcrumbModule,
        ButtonModule,
        EmailFormModule,
        EmailValidationModule,
        CardModule,
        ListModule,
        BreadcrumbModule,
        TemplateListModule,
        ProcessingEmailResourceModule,
        TitleServiceModule,
    ],
    declarations: [
        ProcessingEmailComponent,
    ],
    providers: [
        ProcessingEmailService,
        MailBreadcrumbService,
        HasEmailDataGuard,
        HasSyscodesGuard,
    ]
})
export class ProcessingEmailModule { }